export const SUBSYSTEMS_HEADER: any = {
  QUICK_TICKET: {
    "Content-Type": "application/json",
    "api-key": process.env.REACT_APP_QUICK_TICKET_APP_TOKEN,
  },
};
